export default __webpack_public_path__ + "static/media/animation-arrow.2685c4c9.gif";